import React from 'react';
import { IndexSignals } from '../indices/IndexSignals';

const FUTURES_SYMBOLS = [
  { value: 'ES', label: 'ES (E-mini S&P)' },
  { value: 'MES', label: 'MES (Micro E-mini)' },
  { value: 'NQ', label: 'NQ (E-mini Nasdaq-100)' },
  { value: 'MNQ', label: 'MNQ (Micro Nasdaq)' },
  { value: 'GC', label: 'GC (Gold)' },
  { value: 'CL', label: 'CL (Crude Oil)' },
];

export const FuturesSignals: React.FC = () => (
  <IndexSignals
    symbols={FUTURES_SYMBOLS}
    title="Futures Options Put Selling Signals"
    defaultSymbol="ES"
  />
);
